var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('message-list-common',{attrs:{"messageSeq":_vm.messageSeq}})
}
var staticRenderFns = []

export { render, staticRenderFns }